import * as React from "react";
import { cn } from "@/lib/utils";

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-border bg-card/60 px-3 py-2 text-sm",
        "shadow-sm transition-colors",
        "placeholder:text-muted-foreground",
        "focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/30",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
